import { useLocation } from 'react-router';

import { UI_ROUTES } from '../../util/routes';
import AccountReadyPopup from '../AccountReadyPopup/AccountReadyPopup';
import DemoAccountExpirationPopup from '../DemoAccountExpirationPopup/DemoAccountExpirationPopup';
import SolanaUnsuccessfulPaymentModal from '../SolanaUnsuccessfulPaymentModal/SolanaUnsuccessfulPaymentModal';
import WelcomeSubscriptionPopup from '../WelcomeSubscriptionPopup/WelcomeSubscriptionPopup';

const ModalsManager = () => {
  const location = useLocation();
  const isDashboardScreen = location.pathname.includes(UI_ROUTES.dashboard);
  const isOverviewScreen = location.pathname.includes(UI_ROUTES.overview);

  return (
    <>
      {(isDashboardScreen || isOverviewScreen) && <WelcomeSubscriptionPopup />}
      <AccountReadyPopup />
      <DemoAccountExpirationPopup />
      <SolanaUnsuccessfulPaymentModal />
    </>
  );
};

export default ModalsManager;
